module.exports = ".btn-la {\n    color: white !important;\n    background-color: #b8473d !important;\n}\n"